import { rest } from 'msw';

export const handlers = [
	rest.get(`${process.env.NEXT_PRIVATE_WP_API_URL}/wp-json/wp/v2/posts`, (request, response, context) => {
		const searchParams = request.url.searchParams;
		const categories = searchParams.get('categories');

		if (categories === '16') {
			return response(
				context.status(200),
				context.json([
					{
						id: 14537,
						categories: [136, 16],
						title: {
							rendered: '태양광 모니터링(RTU) 설치비 75%할인 이벤트!',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/05/e2404c89-1280x720-1.png',
								},
							],
						},
					},
					{
						id: 14516,
						categories: [136, 16],
						title: {
							rendered: '엔라이튼, 경기도 RE100 재생에너지 공급사업자 업무협약 체결',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/05/3cfee796-협약식-이미지-e1715590951266.jpeg',
								},
							],
						},
					},
					{
						id: 14506,
						categories: [136, 16],
						title: {
							rendered: '엔라이튼, 대동모빌리티에 국내 최대&#8217;구독형 태양광&#8217;준공 …RE100 공장 달성',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/05/834798f4-준공식_야외1안-scaled-e1715587475777.jpg',
								},
							],
						},
					},
					{
						id: 14458,
						categories: [136, 16, 10],
						title: {
							rendered: '발전왕 모니터링(RTU) 설치비 무료 이벤트!',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/04/efebcfff-1280x720-1.png',
								},
							],
						},
					},
					{
						id: 14370,
						categories: [133, 16, 10],
						title: {
							rendered: '지난 겨울철 전국 태양광 발전시간 분석!',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/02/cbbed2d2-pine-7648311_1280.jpg',
								},
							],
						},
					},
					{
						id: 14358,
						categories: [16, 138, 10],
						title: {
							rendered: '2024년도 신·재생에너지 금융지원사업 지원 공고 발표!',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/02/be0b8627-1124-en.jpg',
								},
							],
						},
					},
					{
						id: 14354,
						categories: [136, 16, 10],
						title: {
							rendered: '엔라이튼, 넥스플렉스에 투자비 0원으로 전기요금 절감 및 RE100 통합 솔루션 제공',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/02/d5c08286-엔라이튼-보도사진엔라이튼-넥스플렉스에-투자비-0원으로-전기요금-절감-및-re100-통합-솔루션-제공.jpg',
								},
							],
						},
					},
					{
						id: 12413,
						categories: [16, 138, 10],
						title: {
							rendered: '2024년 RPS 공급의무자별 의무공급량 발표!',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/02/68896fd0-211124_pr_img_w640.jpg',
								},
							],
						},
					},
				]),
			);
		}

		if (categories === '2348') {
			return response(
				context.status(200),
				context.json([
					{
						id: 12223,
						categories: [2348, 16, 138, 10],
						title: {
							rendered: '2023년 글로벌 RE100 시장 동향은 어땠을까?',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://cms.solarconnect.kr/wp-content/uploads/2022/11/architecture-gc017a7ec8_1920.jpg',
								},
							],
						},
					},
					{
						id: 11872,
						categories: [133, 2348, 16, 10],
						title: {
							rendered: '2023년 태양광 SMP, REC 가격 동향은 어땠을까?',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/01/b5c8c4ad-인사이트-리사이징.jpeg',
								},
							],
						},
					},
					{
						id: 11867,
						categories: [2348, 16, 139, 10],
						title: {
							rendered: '[태양광 인버터 시리즈] 인버터 자주 묻는 질문(FAQ) 한 번에 모아보기',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/01/c32b0355-인사이트-리사이징-230310.jpg',
								},
							],
						},
					},
					{
						id: 11862,
						categories: [2348, 16, 139, 10],
						title: {
							rendered: '[태양광 인버터 시리즈] 1. 태양광 인버터의 기능과 선택 기준 알아보기',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/01/0ae2b23b-인사이트-리사이징-230314.jpg',
								},
							],
						},
					},
					{
						id: 11854,
						categories: [136, 2348, 16, 10],
						title: {
							rendered: '[2023년 발전왕 총결산] 발전왕 주요 소식 모아보기 &#8211; 작년에는 어떤 일들이 있었을까?',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/01/11a30fa7-lightbulb-gadd92b67d_1920.jpg',
								},
							],
						},
					},
					{
						id: 11839,
						categories: [136, 2348, 16, 10],
						title: {
							rendered: '엔라이튼 세미나 현장 스케치-전력 요금 절감 실제 프로젝트 소개',
						},
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.enlighten.kr/2024/01/3f32d6b7-untitled.png',
								},
							],
						},
					},
				]),
			);
		}

		if (categories === '3060') {
			return response(
				context.status(200),
				context.json([
					{
						id: 14516,
						categories: [3060, 3059],
						title: {
							rendered: '홍길동김길동발전소 100MW',
						},
						content: { rendered: '\n<p>주민참여형 컨설팅, 자금조달, 마을법인 운영 관리 중</p>\n' },
						metadata: ['', '', '', '', '', false, '태그'],
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.dev.enlighten.kr/2025/03/rolling_img1-scaled.jpg',
								},
							],
						},
					},
					{
						id: 14514,
						categories: [3060, 3059],
						title: {
							rendered: '홍길동김길동발전소 100MW',
						},
						content: { rendered: '\n<p>주민참여형 컨설팅, 자금조달, 마을법인 운영 관리 중</p>\n' },
						metadata: ['', '', '', '', '', false, '태그'],
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.dev.enlighten.kr/2025/03/rolling_img1-scaled.jpg',
								},
							],
						},
					},
					{
						id: 14502,
						categories: [3060, 3059],
						title: {
							rendered: '양양 만월산 풍력발전소 42MW',
						},
						content: { rendered: '\n<p>주민참여형 컨설팅, 자금조달, 마을법인 운영 관리 중</p>\n' },
						metadata: ['', '', '', '', '', false, '주민 참여형 사업'],
						_embedded: {
							'wp:featuredmedia': [
								{
									source_url: 'https://wp-cdn.dev.enlighten.kr/2026/04/section06-03.png',
								},
							],
						},
					},
				]),
			);
		}

		return response(context.status(200));
	}),
	rest.post('/api/news-letter', async (request, response, context) => {
		return response(
			context.status(200),
			context.body(
				JSON.stringify({
					status: 200,
					code: 'OK',
					message: '구독 신청이 완료되었습니다.',
				}),
			),
			context.delay(500),
		);
	}),
];
